// extracted by mini-css-extract-plugin
export default {"pro-icon-container":"ProportionIcon_pro-icon-container__RIPsF","round":"ProportionIcon_round__XYEYP","center":"ProportionIcon_center__lrzXJ"};